
import assert from "assert";
import { CLM } from "./claims";
import { addDays } from "date-fns";
import { dateOnly_FROM_date } from "@/fx/data-helpers";

export const STAGE_TESTING__VARIANTS = [
  { identifier: "A", label: "A", description: "Beer/FMB Claim"            },
  { identifier: "B", label: "B", description: "Spirits Claim"             },
  { identifier: "C", label: "C", description: "Beer/FMB Claim - Skip TTB" },
]
export const STAGE_TESTING__STAGES: { [key: string]: { identifier: number; label: string; description: string; }[] } = {
  A: [
    { identifier: 10, label: "1", description: "Confirm Claim Approvals" },

    { identifier: 21, label: "2.1", description: "Send Approval to Destroy - Destruction Intent - START"   },
    { identifier: 22, label: "2.2", description: "Send Approval to Destroy - Destruction Intent - SKIPPED" },
    { identifier: 23, label: "2.3", description: "Send Approval to Destroy - Destruction Intent - FILLED"  },
    { identifier: 24, label: "2.4", description: "Send Approval to Destroy - COMPLETE"                     },

    { identifier: 31, label: "3.1", description: "Submit TTB Documents - START"    },
    { identifier: 32, label: "3.2", description: "Submit TTB Documents - COMPLETE" },

    { identifier:  41, label: "4.1", description: "Waiting for TTB approvals"                                 },
    { identifier:  42, label: "4.2", description: "Waiting for TTB approvals - FOLLOW_UP"                     },
    { identifier:  43, label: "4.3", description: "Waiting for TTB approvals - OVERDUE"                       },
    { identifier:  44, label: "4.4", description: "Waiting for TTB approvals - SKIPPED FOLLOW_UP"             },
    { identifier:  45, label: "4.5", description: "Waiting for TTB approvals - SKIPPED FOLLOW_UP + OVERDUE"   },
    { identifier:  46, label: "4.6", description: "Waiting for TTB approvals - CONFIRMED FOLLOW_UP"           },
    { identifier:  47, label: "4.7", description: "Waiting for TTB approvals - CONFIRMED FOLLOW_UP + OVERDUE" },

    { identifier:  51, label: "5.1", description: "Confirm TTB approvals - APPROVED"           },
    { identifier:  52, label: "5.2", description: "Confirm TTB approvals - APPROVED + OVERDUE" },

    { identifier:  61, label: "6.1", description: "Send Approval to Destroy"                                },
    { identifier:  62, label: "6.2", description: "Send Approval to Destroy - FOLLOW_UP"                    },
    { identifier:  63, label: "6.3", description: "Send Approval to Destroy - OVERDUE"                      },
    { identifier:  64, label: "6.4", description: "Send Approval to Destroy - CONFIRMED-OVERDUE"            },
    { identifier:  65, label: "6.5", description: "Send Approval to Destroy - CONFIRMED-OVERDUE + READY"    },
    { identifier:  66, label: "6.6", description: "Send Approval to Destroy - CONFIRMED-OVERDUE + APPROVED" },

    { identifier:  71, label: "7.1", description: "Confirm Destruction Approvals"                                },
    { identifier:  72, label: "7.2", description: "Confirm Destruction Approvals - CONFIRMED-OVERDUE"            },
    { identifier:  73, label: "7.3", description: "Confirm Destruction Approvals - CONFIRMED-OVERDUE + READY"    },
    { identifier:  74, label: "7.4", description: "Confirm Destruction Approvals - CONFIRMED-OVERDUE + APPROVED" },

    { identifier:  81, label: "8.1", description: "Waiting for AODs"                                },
    { identifier:  82, label: "8.2", description: "Waiting for AODs - CONFIRMED-OVERDUE"            },
    { identifier:  83, label: "8.3", description: "Waiting for AODs - CONFIRMED-OVERDUE + READY"    },
    { identifier:  84, label: "8.4", description: "Waiting for AODs - CONFIRMED-OVERDUE + APPROVED" },

    { identifier: 91, label: "9.1", description: "Confirm Destruction - Destroyed LESS"  },
    { identifier: 92, label: "9.2", description: "Confirm Destruction - Destroyed MORE"  },
    { identifier: 93, label: "9.3", description: "Confirm Destruction - Destroyed EQUAL" },

    { identifier: 94, label: "9.4", description: "Confirm Destruction - NO ISSUES"     },
    { identifier: 95, label: "9.5", description: "Confirm Destruction - SINGLE ISSUES" },
    { identifier: 96, label: "9.6", description: "Confirm Destruction - MANY ISSUES"   },
    { identifier: 97, label: "9.7", description: "Confirm Destruction - OTHER ISSUE"   },

    { identifier: 101, label: "10.1", description: "Record Credit Details - NO ISSUES"     },
    { identifier: 102, label: "10.2", description: "Record Credit Details - SINGLE ISSUES" },
    { identifier: 103, label: "10.3", description: "Record Credit Details - MANY ISSUES"   },
    { identifier: 104, label: "10.4", description: "Record Credit Details - OTHER ISSUE"   },

    { identifier: 111, label: "11.1", description: "Confirm Wholesaler Credited"                                },
    { identifier: 112, label: "11.2", description: "Confirm Wholesaler Credited - CONFIRMED-OVERDUE"            },
    { identifier: 113, label: "11.3", description: "Confirm Wholesaler Credited - CONFIRMED-OVERDUE + READY"    },
    { identifier: 114, label: "11.4", description: "Confirm Wholesaler Credited - CONFIRMED-OVERDUE + APPROVED" },

    { identifier: 121, label: "12.1", description: "Archived - Approved for credit"                                },
    { identifier: 122, label: "12.2", description: "Archived - Approved for credit - CONFIRMED-OVERDUE"            },
    { identifier: 123, label: "12.3", description: "Archived - Approved for credit - CONFIRMED-OVERDUE + READY"    },
    { identifier: 124, label: "12.4", description: "Archived - Approved for credit - CONFIRMED-OVERDUE + APPROVED" },
  ],
  B: [
    { identifier: 10, label: "1", description: "Confirm Claim Approvals" },

    { identifier: 21, label: "2.1", description: "Send Approval to Destroy - Destruction Intent - START"   },
    { identifier: 22, label: "2.2", description: "Send Approval to Destroy - Destruction Intent - SKIPPED" },
    { identifier: 23, label: "2.3", description: "Send Approval to Destroy - Destruction Intent - FILLED"  },

    { identifier: 30, label: "3", description: "Confirm Destruction Approvals" },
    { identifier: 40, label: "4", description: "Waiting for AODs"              },

    { identifier: 51, label: "5.1", description: "Confirm destruction - Destroyed LESS"  },
    { identifier: 52, label: "5.2", description: "Confirm destruction - Destroyed MORE"  },
    { identifier: 53, label: "5.3", description: "Confirm destruction - Destroyed EQUAL" },

    { identifier: 60, label: "6", description: "Record Credit Details"       },
    { identifier: 70, label: "7", description: "Confirm Wholesaler Credited" },

    { identifier: 80, label: "8", description: "Archived - Approved for credit" },
  ],
  C: [
    { identifier: 10, label: "1",  description: "Confirm Claim Approvals" },

    { identifier: 21, label: "2.1", description: "Send Approval to Destroy - Destruction Intent - START"   },
    { identifier: 22, label: "2.2", description: "Send Approval to Destroy - Destruction Intent - SKIPPED" },
    { identifier: 23, label: "2.3", description: "Send Approval to Destroy - Destruction Intent - FILLED"  },
    { identifier: 24, label: "2.4", description: "Send Approval to Destroy - NOI Section 1 - PARTIAL"      },
    { identifier: 25, label: "2.5", description: "Send Approval to Destroy - NOI Section 1 - COMPLETE"     },
    { identifier: 26, label: "2.6", description: "Send Approval to Destroy - NOI Section 2 - PARTIAL"      },
    { identifier: 27, label: "2.7", description: "Send Approval to Destroy - NOI Section 2 - COMPLETE"     },

    { identifier: 30, label: "3",  description: "Confirm Destruction Approvals"                          },
    { identifier: 31, label: "3.1",  description: "TTB Approval - PARTIAL"                               },
    { identifier: 32, label: "3.2",  description: "TTB Approval - FILLED"                                },
    { identifier: 33, label: "3.3",  description: "TTB Approval - CONFIRMED"                             },
    { identifier: 34, label: "3.4",  description: "Destruction Approval - PARTIAL + TTB Approval - NONE" },
    { identifier: 35, label: "3.5",  description: "Destruction Approval - FILLED + TTB Approval - NONE"  },

    { identifier: 40, label: "4", description: "Waiting for AODs" },

    { identifier: 51, label: "5.1", description: "Confirm destruction - Destroyed LESS"  },
    { identifier: 52, label: "5.2", description: "Confirm destruction - Destroyed MORE"  },
    { identifier: 53, label: "5.3", description: "Confirm destruction - Destroyed EQUAL" },

    { identifier: 60, label: "6", description: "Record Credit Details"       },
    { identifier: 70, label: "7", description: "Confirm Wholesaler Credited" },

    { identifier: 80, label: "8", description: "Archived - Approved for credit" },
  ]
}
const isValidVariant = (variant: string               ) => STAGE_TESTING__VARIANTS       .map(_ => _.identifier).includes(variant);
const isValidStage   = (variant: string, stage: number) => STAGE_TESTING__STAGES[variant].map(_ => _.identifier).includes(stage  );

const deadlines = (ctx: () => CLM.ClaimCleanupContext) => {
  const { now } = ctx();

  const ttbApprovalDeadline_OK        = dateOnly_FROM_date(addDays(now, CLM.timeEstimates.TTB_FOLLOW_UP + 1));
  const ttbApprovalDeadline_FOLLOW_UP = dateOnly_FROM_date(addDays(now, CLM.timeEstimates.TTB_FOLLOW_UP - 1));
  const ttbApprovalDeadline_OVERDUE   = dateOnly_FROM_date(addDays(now, -1 ));

  return {
    dateFaxedToTtb_OK:        addDays(ttbApprovalDeadline_OK,        -CLM.timeEstimates.TTB_APPROVAL),
    dateFaxedToTtb_FOLLOW_UP: addDays(ttbApprovalDeadline_FOLLOW_UP, -CLM.timeEstimates.TTB_APPROVAL),
    dateFaxedToTtb_OVERDUE:   addDays(ttbApprovalDeadline_OVERDUE,   -CLM.timeEstimates.TTB_APPROVAL),

    ttbApprovalDeadline_OK,
    ttbApprovalDeadline_FOLLOW_UP,
    ttbApprovalDeadline_OVERDUE,
  }
}

const demoClaim_processFields_FOR = (ctx: () => CLM.ClaimCleanupContext) => ({ variant, stage }: {
  variant: string,
  stage:   number
}) => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);
  const { ttbApprovalDeadline_OK, ttbApprovalDeadline_FOLLOW_UP, ttbApprovalDeadline_OVERDUE } = deadlines(ctx);
  switch (`${variant}-${stage}`) {
    case "A-10": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.claimApproval.confirmClaimApprovals())

    case "A-21":
    case "A-22":
    case "A-23":
    case "A-24": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.prepareTtbSubmission())

    case "A-31":
    case "A-32": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.sendTtbSubmission())

    case "A-41": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.waitingForTtbApprovals({ ttbApprovalDeadline: ttbApprovalDeadline_OK        }))
    case "A-42": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.waitingForTtbApprovals({ ttbApprovalDeadline: ttbApprovalDeadline_FOLLOW_UP }))
    case "A-43": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.waitingForTtbApprovals({ ttbApprovalDeadline: ttbApprovalDeadline_OVERDUE   }))
    case "A-44": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.waitingForTtbApprovals({ ttbApprovalDeadline: ttbApprovalDeadline_FOLLOW_UP }))
    case "A-45": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.waitingForTtbApprovals({ ttbApprovalDeadline: ttbApprovalDeadline_OVERDUE   }))
    case "A-46": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.waitingForTtbApprovals({ ttbApprovalDeadline: ttbApprovalDeadline_FOLLOW_UP }))
    case "A-47": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.waitingForTtbApprovals({ ttbApprovalDeadline: ttbApprovalDeadline_OVERDUE   }))

    case "A-51":
    case "A-52": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.confirmTtbApprovals())

    case "A-61":
    case "A-62":
    case "A-63":
    case "A-64":
    case "A-65":
    case "A-66": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.sendApprovalToDestroy())

    case "A-71":
    case "A-72":
    case "A-73":
    case "A-74": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.confirmDestructionApprovals())

    case "A-81":
    case "A-82":
    case "A-83":
    case "A-84": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.waitingForAods())

    case "A-91":
    case "A-92":
    case "A-93":
    case "A-94":
    case "A-95":
    case "A-96":
    case "A-97": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.confirmDestruction())

    case "A-101":
    case "A-102":
    case "A-103":
    case "A-104": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.wholesalerCreditApproval.recordCreditTotals())

    case "A-111":
    case "A-112":
    case "A-113":
    case "A-114": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.wholesalerCreditApproval.approveClaimForCredit())

    case "A-121":
    case "A-122":
    case "A-123":
    case "A-124": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.archived.wholesalerCredited())

    case "B-10": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.claimApproval.confirmClaimApprovals())

    case "B-21":
    case "B-22":
    case "B-23": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.sendApprovalToDestroy())

    case "B-30": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.confirmDestructionApprovals())
    case "B-40": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.waitingForAods             ())

    case "B-51":
    case "B-52":
    case "B-53": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.confirmDestruction())

    case "B-60": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.wholesalerCreditApproval.recordCreditTotals   ())
    case "B-70": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.wholesalerCreditApproval.approveClaimForCredit())

    case "B-80": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.archived.wholesalerCredited())

    case "C-10": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.claimApproval.confirmClaimApprovals())

    case "C-21":
    case "C-22":
    case "C-23":
    case "C-24":
    case "C-25":
    case "C-26":
    case "C-27": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.sendApprovalToDestroy())

    case "C-30": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.confirmDestructionApprovals())
    case "C-31": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.sendApprovalToDestroy())
    case "C-32":
    case "C-33": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.ttbApproval.confirmTtbApprovals())
    case "C-34":
    case "C-35": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.confirmDestructionApprovals())

    case "C-40": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.waitingForAods())

    case "C-51":
    case "C-52":
    case "C-53": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.destruction.confirmDestruction())

    case "C-60": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.wholesalerCreditApproval.recordCreditTotals   ())
    case "C-70": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.wholesalerCreditApproval.approveClaimForCredit())

    case "C-80": return CLM.toRawClaimProcessFields(CLM.claimProcessFields_FOR.archived.wholesalerCredited())

    default: assert(false, `Unexpected stage: ${variant}-${stage}`);
  }
}
const demoClaim_extension_FOR = (ctx: () => CLM.ClaimCleanupContext) => ({ variant, stage }: {
  variant: string,
  stage:   number
}): Partial<CLM.ClaimExtensionOneRaw> => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);
  switch (`${variant}-${stage}`) {
    case "A-10":
    case "A-21":
    case "A-22":
    case "A-23":
    case "A-24":
    case "A-31":
    case "A-32":
    case "A-41":
    case "A-42":
    case "A-43":
    case "A-44":
    case "A-45":
    case "A-46":
    case "A-47":
    case "A-51":
    case "A-52":
    case "A-61":
    case "A-62":
    case "A-63":
    case "A-64":
    case "A-65":
    case "A-66":
    case "A-71":
    case "A-72":
    case "A-73":
    case "A-74":
    case "A-81":
    case "A-82":
    case "A-83":
    case "A-84":
    case "A-91":
    case "A-92":
    case "A-93":
    case "A-94":
    case "A-95":
    case "A-96":
    case "A-97":
    case "A-101":
    case "A-102":
    case "A-103":
    case "A-104":
    case "A-111":
    case "A-112":
    case "A-113":
    case "A-114":
    case "A-121":
    case "A-122":
    case "A-123":
    case "A-124":

    case "B-10":
    case "B-21":
    case "B-22":
    case "B-23":
    case "B-30":
    case "B-40":
    case "B-51":
    case "B-52":
    case "B-53":
    case "B-60":
    case "B-70":
    case "B-80":

    case "C-10":
    case "C-21":
    case "C-22":
    case "C-23":
    case "C-24":
    case "C-25":
    case "C-26":
    case "C-27":
    case "C-30":
    case "C-31":
    case "C-32":
    case "C-33":
    case "C-34":
    case "C-35":
    case "C-40":
    case "C-51":
    case "C-52":
    case "C-53":
    case "C-60":
    case "C-70":
    case "C-80": return { }

    default: assert(false, `Unexpected stage: ${variant}-${stage}`);
  }
}
const demoClaim_overrides_FOR = (ctx: () => CLM.ClaimCleanupContext) => ({ variant, stage }: {
  variant: string,
  stage:   number
}): Partial<CLM.RawClaim> => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);
  const { now } = ctx();
  const {
    dateFaxedToTtb_OK,        ttbApprovalDeadline_OK,
    dateFaxedToTtb_FOLLOW_UP, ttbApprovalDeadline_FOLLOW_UP,
    dateFaxedToTtb_OVERDUE,   ttbApprovalDeadline_OVERDUE,
  } = deadlines(ctx);
  const CONFIRMED_OVERDUE__1__RESET = {
    ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OK     ).toISOString(),
    ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OK).toISOString(),

    ttb_ttbFollowUpConfirmedAt:        undefined,
    ttb_overdueTtbApprovalConfirmedAt: undefined,
  };
  const CONFIRMED_OVERDUE__2__SET = {
    ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OVERDUE     ).toISOString(),
    ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OVERDUE).toISOString(),

    ttb_ttbFollowUpConfirmedAt:        now.toISOString(),
    ttb_overdueTtbApprovalConfirmedAt: now.toISOString(),

    ttb_ttbApprovalConfirmed:   false,
    ttb_ttbApprovalDate:        undefined,
    ttb_ttbApproval_id:         undefined,
    ttb_ttbApproval_fileName:   undefined,
    ttb_ttbApproval_uploadedAt: undefined,
  };
  const CONFIRMED_OVERDUE__3__READY = {
    ttb_ttbApprovalDate:        stripTime(addDays(now, -2)).toISOString(),
    ttb_ttbApproval_id:         "333",
    ttb_ttbApproval_fileName:   "TTB Approval 24-09D.pdf",
    ttb_ttbApproval_uploadedAt: "2024-03-15T12:00:00Z",
  };
  const CONFIRMED_OVERDUE__4__APPROVED = {
    ttb_ttbApprovalConfirmed: true,
  };

  switch (`${variant}-${stage}`) {
    case "A-10": return {
      beverageType:            CLM.BeverageType.BEER_FMB.identifier,
      noi:                     "24-00D",
      wholesaler_nameOverride: "Bean Town Distributing, Inc.",
      claimForm_id:            "1",
      claimForm_fileName:      "Claim Form 24-00D.pdf",
      claimForm_uploadedAt:    "2024-03-13T12:00:00Z",
    }
    case "B-10": return {
      beverageType:            CLM.BeverageType.SPIRITS.identifier,
      noi:                     undefined,
      wholesaler_nameOverride: "Bean Town Distributing, Inc.",
      claimForm_id:            "1",
      claimForm_fileName:      "Claim Form 24-00D.pdf",
      claimForm_uploadedAt:    "2024-03-13T12:00:00Z",
    }
    case "C-10": return {
      skipTtb:                    true,
      skipTtb_skipReason:         "Skipped by the user",
      skipTtb_deferredTaxCredit:  1_029.19,
      beverageType:             CLM.BeverageType.BEER_FMB.identifier,
      noi:                      "24-00D",
      wholesaler_nameOverride:  "Bean Town Distributing, Inc.",
      claimForm_id:             "1",
      claimForm_fileName:       "Claim Form 24-00D.pdf",
      claimForm_uploadedAt:     "2024-03-13T12:00:00Z",
    }
    case "A-21":
    case "B-21":
    case "C-21": return { }
    case "B-22":
    case "C-22": return {
      bbc_destructionApprovalDate:        "2024-03-15T00:00:00Z",
      bbc_destructionApproval_id:         "444",
      bbc_destructionApproval_fileName:   "Destruction Approval C24-0013.pdf",
      bbc_destructionApproval_uploadedAt: "2024-03-15T12:00:00Z",
    }
    case "A-23":
    case "B-23":
    case "C-23": return {
      di_destructionCompany_type:          CLM.DestructionCompanyType.WHOLESALER.identifier,
      di_destructionCompany_name:          "Bean Town Distributing, Inc. - 555BTD",
      di_destructionCompany_streetAddress: "55 Fenway Street",
      di_destructionCompany_city:          "Woburn",
      di_destructionCompany_state:         "MA",
      di_destructionCompany_zipCode:       "55510",
      di_destructionMethod:                "Dumpster",

      ttb_alcoholicCases:      undefined,
      ttb_barrels:             undefined,
      ttb_tax:                 undefined,
      ttb_productionLocations: undefined,

      bbc_destructionApprovalDate:        undefined,
      bbc_destructionApproval_id:         undefined,
      bbc_destructionApproval_fileName:   undefined,
      bbc_destructionApproval_uploadedAt: undefined,
    }
    case "C-24": return {
      ttb_barrels:             57.177,
      ttb_productionLocations: [CLM.ProductionLocation["BR-AZ-20145"].identifier, CLM.ProductionLocation["BR-CA-AME-15003"].identifier].join(","),
    }
    case "A-22":
    case "A-24":
    case "C-25": return {
      ttb_alcoholicCases:      787,
      ttb_barrels:             57.177,
      ttb_tax:                 1_029.19,
      ttb_productionLocations: [CLM.ProductionLocation["BR-AZ-20145"].identifier, CLM.ProductionLocation["BR-CA-AME-15003"].identifier].join(","),
    }
    case "A-31": return { }
    case "C-26": return {
      ttb_noticeOfIntent_id:         "111",
      ttb_noticeOfIntent_fileName:   "Notice of Intent 24-09D.pdf",
      ttb_noticeOfIntent_uploadedAt: "2024-03-12T12:00:00Z",
    }
    case "A-32":
    case "C-27": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OK     ).toISOString(),

      ttb_noticeOfIntent_id:         "111",
      ttb_noticeOfIntent_fileName:   "Notice of Intent 24-09D.pdf",
      ttb_noticeOfIntent_uploadedAt: "2024-03-12T12:00:00Z",
      ttb_faxCoverSheet_id:          "222",
      ttb_faxCoverSheet_fileName:    "Fax Cover Sheet 24-09D.pdf",
      ttb_faxCoverSheet_uploadedAt:  "2024-03-14T12:00:00Z",
    }
    case "A-41": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OK     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OK).toISOString(),
    }
    case "A-42": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_FOLLOW_UP     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_FOLLOW_UP).toISOString(),
    }
    case "A-43": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OVERDUE     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OVERDUE).toISOString(),
    }
    case "A-44": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_FOLLOW_UP     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_FOLLOW_UP).toISOString(),

      ttb_skipTtbFollowUp:        true,
      ttb_ttbFollowUpConfirmedAt: undefined,
    }
    case "A-45": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OVERDUE     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OVERDUE).toISOString(),
    }
    case "A-46": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_FOLLOW_UP     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_FOLLOW_UP).toISOString(),

      ttb_skipTtbFollowUp:        false,
      ttb_ttbFollowUpConfirmedAt: now.toISOString(),
    }
    case "A-47": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OVERDUE     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OVERDUE).toISOString(),
    }
    case "A-51": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OK     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OK).toISOString(),

      ttb_skipTtbFollowUp:        false,
      ttb_ttbFollowUpConfirmedAt: undefined,

      ttb_overdueTtbApprovalConfirmedAt: undefined,

      ttb_ttbApprovalDate:        stripTime(addDays(now, -2)).toISOString(),
      ttb_ttbApproval_id:         "333",
      ttb_ttbApproval_fileName:   "TTB Approval 24-09D.pdf",
      ttb_ttbApproval_uploadedAt: "2024-03-15T12:00:00Z",
    }
    case "A-52": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OVERDUE     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OVERDUE).toISOString(),

      ttb_ttbFollowUpConfirmedAt: now.toISOString(),
    }
    case "A-61": return {
      ...CONFIRMED_OVERDUE__1__RESET,

      ttb_ttbApprovalConfirmed: true,
    }
    case "A-62": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_FOLLOW_UP     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_FOLLOW_UP).toISOString(),
    }
    case "A-63": return {
      ttb_dateFaxedToTTB:      stripTime(dateFaxedToTtb_OVERDUE     ).toISOString(),
      ttb_ttbApprovalDeadline: stripTime(ttbApprovalDeadline_OVERDUE).toISOString(),
    }
    case "A-64": return {
      ...CONFIRMED_OVERDUE__2__SET,
    }
    case "A-65": return {
      ...CONFIRMED_OVERDUE__3__READY,
    }
    case "A-66": return {
      ...CONFIRMED_OVERDUE__4__APPROVED,
    }
    case "A-71": return {
      ...CONFIRMED_OVERDUE__1__RESET,

      bbc_destructionApprovalDate:        "2024-03-15T00:00:00Z",
      bbc_destructionApproval_id:         "444",
      bbc_destructionApproval_fileName:   "Destruction Approval C24-0013.pdf",
      bbc_destructionApproval_uploadedAt: "2024-03-15T12:00:00Z",
    }
    case "A-72": return {
      ...CONFIRMED_OVERDUE__2__SET,
    }
    case "A-73": return {
      ...CONFIRMED_OVERDUE__3__READY,
    }
    case "A-74": return {
      ...CONFIRMED_OVERDUE__4__APPROVED,
    }
    case "B-30": return {
      bbc_destructionApprovalDate:        "2024-03-15T00:00:00Z",
      bbc_destructionApproval_id:         "444",
      bbc_destructionApproval_fileName:   "Destruction Approval C24-0013.pdf",
      bbc_destructionApproval_uploadedAt: "2024-03-15T12:00:00Z",
    }
    case "C-30": return {
      ttb_alcoholicCases:      undefined,
      ttb_barrels:             undefined,
      ttb_tax:                 undefined,
      ttb_productionLocations: undefined,

      ttb_dateFaxedToTTB:            undefined,
      ttb_noticeOfIntent_id:         undefined,
      ttb_noticeOfIntent_fileName:   undefined,
      ttb_noticeOfIntent_uploadedAt: undefined,
      ttb_faxCoverSheet_id:          undefined,
      ttb_faxCoverSheet_fileName:    undefined,
      ttb_faxCoverSheet_uploadedAt:  undefined,
      ttb_ttbApprovalDeadline:       undefined,

      bbc_destructionApprovalDate:        "2024-03-15T00:00:00Z",
      bbc_destructionApproval_id:         "444",
      bbc_destructionApproval_fileName:   "Destruction Approval C24-0013.pdf",
      bbc_destructionApproval_uploadedAt: "2024-03-15T12:00:00Z",
    }
    case "C-31": return {
      keyMoment_ttbSubmissionConfirmedAt:      "2024-03-15T00:00:00Z",
      keyMoment_ttbSubmissionConfirmedBy_id:   "1001001",
      keyMoment_ttbSubmissionConfirmedBy_name: "Jane Doe",
      ttb_ttbApprovalDeadline:        stripTime(ttbApprovalDeadline_OK).toISOString(),

      bbc_destructionApprovalDate:        undefined,
      bbc_destructionApproval_id:         undefined,
      bbc_destructionApproval_fileName:   undefined,
      bbc_destructionApproval_uploadedAt: undefined,
    }
    case "C-32": return {
      ttb_ttbApprovalDate:        "2024-03-15T00:00:00Z",
      ttb_ttbApproval_id:         "333",
      ttb_ttbApproval_fileName:   "TTB Approval 24-09D.pdf",
      ttb_ttbApproval_uploadedAt: "2024-03-15T12:00:00Z",
    }
    case "C-33": return {
    }
    case "C-34": return {
      ttb_ttbApprovalDate:        undefined,
      ttb_ttbApproval_id:         undefined,
      ttb_ttbApproval_fileName:   undefined,
      ttb_ttbApproval_uploadedAt: undefined,

      bbc_destructionApprovalDate: "2024-03-15T00:00:00Z",
      bbc_destructionApproval_id:  "444",
    }
    case "C-35": return {
      bbc_destructionApproval_fileName:   "Destruction Approval C24-0013.pdf",
      bbc_destructionApproval_uploadedAt: "2024-03-15T12:00:00Z",
    }
    case "A-81": return {
      ...CONFIRMED_OVERDUE__1__RESET,
    }
    case "A-82": return {
      ...CONFIRMED_OVERDUE__2__SET,
    }
    case "A-83": return {
      ...CONFIRMED_OVERDUE__3__READY,
    }
    case "A-84": return {
      ...CONFIRMED_OVERDUE__4__APPROVED,
    }
    case "B-40":
    case "C-40": return { }
    case "A-91": return {
      ...CONFIRMED_OVERDUE__1__RESET,

      aod_earliestDestructionDate: "2024-03-18T00:00:00Z",
      aod_casesDestroyed: 666,
      aod_hasIssues:      false,
      aod_issues:         undefined,
      aod_reviewNotes:    "Some review notes.",
      // affidavits:      [],
      aod_1_id:           "11",
      aod_1_fileName:     "AOD C24-0013 - 1.pdf",
      aod_1_uploadedAt:   "2024-03-18T12:00:00Z",
      aod_2_id:           "22",
      aod_2_fileName:     "AOD C24-0013 - 2.pdf",
      aod_2_uploadedAt:   "2024-03-18T12:00:00Z",
      aod_3_id:           "33",
      aod_3_fileName:     "AOD C24-0013 - 3.pdf",
      aod_3_uploadedAt:   "2024-03-18T12:00:00Z",
    }
    case "B-51":
    case "C-51": return {
      aod_earliestDestructionDate: "2024-03-18T00:00:00Z",
      aod_casesDestroyed: 666,
      aod_hasIssues:      false,
      aod_issues:         undefined,
      aod_reviewNotes:    "Some review notes.",
      // affidavits:      [],
      aod_1_id:           "11",
      aod_1_fileName:     "AOD C24-0013 - 1.pdf",
      aod_1_uploadedAt:   "2024-03-18T12:00:00Z",
      aod_2_id:           "22",
      aod_2_fileName:     "AOD C24-0013 - 2.pdf",
      aod_2_uploadedAt:   "2024-03-18T12:00:00Z",
      aod_3_id:           "33",
      aod_3_fileName:     "AOD C24-0013 - 3.pdf",
      aod_3_uploadedAt:   "2024-03-18T12:00:00Z",
    }
    case "A-92":
    case "B-52":
    case "C-52": return {
      aod_casesDestroyed: 999,
    }
    case "A-93":
    case "B-53":
    case "C-53": return {
      aod_casesDestroyed: 807,
    }
    case "A-94": return {
      aod_hasIssues: false,
      aod_issues:    undefined,
    }
    case "A-95": return {
      aod_hasIssues: true,
      aod_issues:    [CLM.AodIssue.INVALID_NOI.identifier].join(","),
    }
    case "A-96": return {
      aod_hasIssues: true,
      aod_issues:    [CLM.AodIssue.INVALID_NOI.identifier, CLM.AodIssue.INVALID_SIGNATURES.identifier].join(","),
    }
    case "A-97": return {
      aod_hasIssues: true,
      aod_issues:    [CLM.AodIssue.OTHER.identifier].join(","),
    }

    case "A-101":
    case "B-60":
    case "C-60": return {
      aod_hasIssues:     false,
      aod_issues:        undefined,
      acc_casesCredited: 807,
    }
    case "A-102": return {
      aod_hasIssues: true,
      aod_issues:    [CLM.AodIssue.INVALID_NOI.identifier].join(","),
    }
    case "A-103": return {
      aod_hasIssues: true,
      aod_issues:    [CLM.AodIssue.INVALID_NOI.identifier, CLM.AodIssue.INVALID_SIGNATURES.identifier].join(","),
    }
    case "A-104": return {
      aod_hasIssues: true,
      aod_issues:    [CLM.AodIssue.OTHER.identifier].join(","),
    }
    case "A-111": return {
      ...CONFIRMED_OVERDUE__1__RESET,

      aod_hasIssues:     false,
      aod_issues:        undefined,
      acc_casesCredited: 807,
      acc_creditAmount:  1_000.00,
      acc_creditProcessingNotes: "Some processing notes.",
    }
    case "B-70":
    case "C-70": return {
      aod_hasIssues:     false,
      aod_issues:        undefined,
      acc_casesCredited: 807,
      acc_creditAmount:  1_000.00,
      acc_creditProcessingNotes: "Some processing notes.",
    }
    case "A-112": return {
      ...CONFIRMED_OVERDUE__2__SET,
    }
    case "A-113": return {
      ...CONFIRMED_OVERDUE__3__READY,
    }
    case "A-114": return {
      ...CONFIRMED_OVERDUE__4__APPROVED,
    }
    case "A-121": return {
      ...CONFIRMED_OVERDUE__1__RESET,
    }
    case "B-80":
    case "C-80": return { }
    case "A-122": return {
      ...CONFIRMED_OVERDUE__2__SET,
    }
    case "A-123": return {
      ...CONFIRMED_OVERDUE__3__READY,
    }
    case "A-124": return {
      ...CONFIRMED_OVERDUE__4__APPROVED,
    }
    default: assert(false, "Unexpected code path.");
  }
}

const demoClaim_extension = (ctx: () => CLM.ClaimCleanupContext) => ({ variant, stage }: {
  variant: string,
  stage:   number
}): CLM.ClaimExtensionOneRaw => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);

  const stageSpecificFields = STAGE_TESTING__STAGES[variant].map(_ => _.identifier)
    .filter(_ => _ <= stage)
    .map(_ => demoClaim_extension_FOR(ctx)({ variant, stage: _ }))
    .reduce((acc, _) => ({ ...acc, ..._ }), { });

  return {
    ...CLM.EXTENSION_ONE_DEFAULTS,
    ...stageSpecificFields,
    __stageTesting_variant: variant,
    __stageTesting_stage:   stage,
  }
}
const demoClaim_overrides = (ctx: () => CLM.ClaimCleanupContext) => ({ variant, stage }: {
  variant: string,
  stage:   number
}): Partial<CLM.RawClaim> => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);

  const stageSpecificFields = STAGE_TESTING__STAGES[variant].map(_ => _.identifier)
    .filter(_ => _ <= stage)
    .map(_ => demoClaim_overrides_FOR(ctx)({ variant, stage: _ }))
    .reduce((acc, _) => ({ ...acc, ..._ }), { });

  return {
    ...stageSpecificFields,
  }
}

const demoClaim_withProcessFields = (ctx: () => CLM.ClaimCleanupContext) => ({ variant, stage }: {
  variant: string,
  stage:   number
}) => (_: CLM.RawClaim): CLM.RawClaim => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);
  return {
    ..._,
    ...demoClaim_processFields_FOR(ctx)({ variant, stage }),
  };
}
const demoClaim_withExtension = (ctx: () => CLM.ClaimCleanupContext) => ({ variant, stage }: {
  variant: string,
  stage:   number
}) => (_: CLM.RawClaim): CLM.RawClaim => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);
  assert(_.extensionOne === undefined);
  return {
    ..._,
    extensionOne: demoClaim_extension(ctx)({ variant, stage }),
  };
}
const demoClaim_withOverrides = (ctx: () => CLM.ClaimCleanupContext) => ({ variant: variant, stage }: {
  variant: string,
  stage:   number
}) => (_: CLM.RawClaim): CLM.RawClaim => {
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);
  return {
    ..._,
    ...demoClaim_overrides(ctx)({ variant, stage }),
  };
}

const enrichedClaim = (ctx: () => CLM.ClaimCleanupContext) => (_: CLM.RawClaim): CLM.RawClaim => [_]
  .map(CLM.fromRawClaim(ctx))
  .map(CLM.claim       (ctx))
  .map(CLM.toRawClaim)
  .at(0)!

export const demoClaim = (ctx: () => CLM.ClaimCleanupContext) => (_: CLM.RawClaim): CLM.RawClaim => {
  assert(_ !== undefined);
  assert(_.id === "1");

  assert(_.wholesaler_nameOverride !== undefined);
  const data = JSON.parse(_.wholesaler_nameOverride);
  assert(data !== undefined);

  const { variant, stage: stage_ } = data;
  const stage = Number(stage_);
  assert(isValidVariant(variant       ), `Invalid variant: ${variant}`);
  assert(isValidStage  (variant, stage), `Invalid stage: ${stage} for variant: ${variant}`);

  const baselineClaim = { ..._, wholesaler_nameOverride: undefined };

  return [baselineClaim]
    .map(demoClaim_withProcessFields(ctx)({ variant, stage }))
    .map(demoClaim_withExtension    (ctx)({ variant, stage }))
    .map(demoClaim_withOverrides    (ctx)({ variant, stage }))
    .map(enrichedClaim              (ctx))
    .at(0)!
}

const stripTime = (date: Date) => dateOnly_FROM_date(date);
